import { render } from "./ModalUploadFile.vue?vue&type=template&id=f25bd072&ts=true"
import script from "./ModalUploadFile.vue?vue&type=script&lang=ts"
export * from "./ModalUploadFile.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__